import { useState } from 'react';
import { cn } from '@/lib/cn';

interface StarProps {
  on: boolean;
  onToggle: () => void;
  className?: string;
}

/** Favourite toggle: filled gold when on, hollow faint when off, one scale pulse on tap. */
export function Star({ on, onToggle, className }: StarProps) {
  const [pulsing, setPulsing] = useState(false);
  return (
    <button
      type="button"
      aria-label={on ? 'Remove favourite' : 'Favourite'}
      aria-pressed={on}
      onClick={() => {
        setPulsing(true);
        onToggle();
      }}
      onAnimationEnd={() => setPulsing(false)}
      className={cn(
        'w-6 shrink-0 text-right text-[17px] leading-none',
        on ? 'text-acc' : 'text-faint',
        pulsing && 'star-pulse',
        className
      )}
    >
      {on ? '★' : '☆'}
    </button>
  );
}
